export default "__VITE_ASSET__115ism4Q__"